module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view"
  }, [(_vm.myUser.email == 'wp@milk-studio.dk' || _vm.myUser.email == 'db@milk-studio.dk') ? _c('box', {
    attrs: {
      "label": _vm.projects_without_timeline.length + ' projekter uden start/slut-dato'
    }
  }, [_vm._l((_vm.projects_without_timeline), function(project, project_i) {
    return [_c('btn', {
      nativeOn: {
        "click": function($event) {
          return _vm.goto('project/' + project['.key'])
        }
      }
    }, [_vm._v(_vm._s(project.name))]), _vm._v("  \n\t\t\t")]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.myUser.email == 'wp@milk-studio.dk' || _vm.myUser.email == 'db@milk-studio.dk') ? _c('box', {
    attrs: {
      "label": _vm.projects_without_budget.length + ' Projekter uden budget'
    }
  }, [_vm._l((_vm.projects_without_budget), function(project, project_i) {
    return [_c('btn', {
      nativeOn: {
        "click": function($event) {
          return _vm.goto('project/' + project['.key'])
        }
      }
    }, [_vm._v(_vm._s(project.name))]), _vm._v("  \n\t\t\t")]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.myUser.email == 'wp@milk-studio.dk' || _vm.myUser.email == 'db@milk-studio.dk') ? _c('box', {
    attrs: {
      "label": _vm.active_projects_beyond_end_date.length + ' Afsluttede projekter?'
    }
  }, [_vm._l((_vm.active_projects_beyond_end_date), function(project, project_i) {
    return [_c('btn', {
      nativeOn: {
        "click": function($event) {
          return _vm.goto('project/' + project['.key'])
        }
      }
    }, [_vm._v(_vm._s(project.name))]), _vm._v("  \n\t\t\t")]
  })], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f88c7190","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Report_missing_input.vue
// module id = 628
// module chunks = 1